/**
 * FH-A11Y batch 15 (2026-09-26): Globo price slider, keyboard use.
 * Each arrow key press moved the price by 1 cent and immediately re-ran the filter; the filter panel
 * was then rebuilt, which threw keyboard focus back to the top of the page. Now the arrow keys move
 * by a sensible amount (Page Up / Page Down by more, Home / End to the ends), the filter runs once
 * you pause (or press Enter), and focus returns to the same slider handle afterwards.
 * Rollback: remove the ada-a11y-batch15.js line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch15) return;
  window.__fhA11yBatch15 = true;

  var KEYS = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1, PageUp: 5, PageDown: -5, Home: 'min', End: 'max' };
  var pending = null;   /* { slider id, values, timer } waiting to be applied */
  var restore = null;   /* { id, handle, until } focus to put back after the panel is rebuilt */

  function niceStep(span) {
    var raw = span / 50;
    var p = Math.pow(10, Math.floor(Math.log10(raw)));
    var n = raw / p;
    return (n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10) * p;
  }
  function money(v) { return '$' + Number(v).toFixed(2); }
  function round2(v) { return Math.round(v * 100) / 100; }

  function sliderInfo(slider) {
    var api = slider.noUiSlider;
    if (!api) return null;
    var min = parseFloat(slider.getAttribute('data-min'));
    var max = parseFloat(slider.getAttribute('data-max'));
    var r = api.options && api.options.range;
    if (isNaN(min) && r) min = +r.min;
    if (isNaN(max) && r) max = +r.max;
    return { api: api, min: min, max: max, id: slider.getAttribute('data-attribute') || slider.getAttribute('data-id') };
  }

  function setInputs(id, a, b) {
    var lo = document.getElementById('min-' + id);
    var hi = document.getElementById('max-' + id);
    if (lo) { lo.value = a; lo.setAttribute('data-value', a); }
    if (hi) { hi.value = b; hi.setAttribute('data-value', b); }
  }

  function commit() {
    if (!pending) return;
    var p = pending; pending = null;
    clearTimeout(p.timer);
    var slider = document.getElementById('slider-' + p.id);
    var info = slider && sliderInfo(slider);
    if (!info) return;
    var v = info.api.get().map(parseFloat);
    restore = { id: p.id, handle: p.handle, until: Date.now() + 15000 };
    if (round2(v[0]) !== round2(info.min) || round2(v[1]) !== round2(info.max)) {
      if (typeof window.addRangeFilter === 'function') window.addRangeFilter(p.id, v[0] + ':' + v[1]);
    } else if (typeof window.removeFilter === 'function') {
      window.removeFilter(p.id);
    }
  }

  document.addEventListener('keydown', function (e) {
    var h = e.target;
    if (!h || !h.classList || !h.classList.contains('noUi-handle')) return;
    var slider = h.closest('.gf-range-slider');
    if (!slider) return;
    if (e.key === 'Enter') { if (pending) { e.preventDefault(); commit(); } return; }
    var k = KEYS[e.key];
    if (k === undefined || e.altKey || e.ctrlKey || e.metaKey) return;
    var info = sliderInfo(slider);
    if (!info) return;
    /* Handle it here, so the slider doesn't also run its own 1-cent step and immediate filter. */
    e.preventDefault();
    e.stopPropagation();
    var idx = h.getAttribute('data-handle') === '1' ? 1 : 0;
    var v = info.api.get().map(parseFloat);
    var step = niceStep(info.max - info.min);
    var nv;
    if (k === 'min') nv = idx ? v[0] : info.min;
    else if (k === 'max') nv = idx ? info.max : v[1];
    else {
      var cur = v[idx];
      nv = k > 0 ? (Math.floor(cur / step) + k) * step : (Math.ceil(cur / step) + k) * step;
      nv = Math.min(info.max, Math.max(info.min, nv));
      if (idx === 0) nv = Math.min(nv, v[1]); else nv = Math.max(nv, v[0]);
    }
    nv = round2(nv);
    info.api.setHandle(idx, nv, false);
    var now = info.api.get().map(parseFloat);
    setInputs(info.id, now[0], now[1]);
    h.setAttribute('aria-valuetext', money(now[idx]));
    if (pending) clearTimeout(pending.timer);
    pending = { id: info.id, handle: idx, timer: setTimeout(commit, 1200) };
  }, true);

  /* Leaving the slider applies any change straight away. */
  document.addEventListener('focusout', function (e) {
    if (pending && e.target.classList && e.target.classList.contains('noUi-handle')) {
      var to = e.relatedTarget;
      if (!to || !to.closest || !to.closest('#slider-' + pending.id)) commit();
    }
  }, true);

  /* After the filter runs, the panel is rebuilt and focus falls back to the page. Put it back. */
  function checkRestore() {
    if (!restore) return;
    if (Date.now() > restore.until) { restore = null; return; }
    var a = document.activeElement;
    if (a && a !== document.body && a !== document.documentElement && a.isConnected) {
      /* Still on the slider: keep watching (the panel may be rebuilt more than once). Elsewhere: stop. */
      if (!a.closest || !a.closest('.gf-range-slider')) restore = null;
      else restore.until = Math.max(restore.until, Date.now() + 5000);
      return;
    }
    var h = document.querySelector('#slider-' + restore.id + ' .noUi-handle[data-handle="' + restore.handle + '"]');
    if (h && h.getClientRects().length) {
      try { h.focus({ preventScroll: true }); } catch (err) { h.focus(); }
    }
  }
  /* Clicking or tapping somewhere else means the user has moved on. */
  document.addEventListener('pointerdown', function () { restore = null; }, true);
  /* Tabbing on to something else also means the user has moved on. */
  document.addEventListener('focusin', function (e) {
    if (restore && e.target.closest && !e.target.closest('.gf-range-slider')) restore = null;
  }, true);
  new MutationObserver(checkRestore).observe(document.documentElement, { childList: true, subtree: true });
  setInterval(checkRestore, 250);
})();
